(function() {
  "use strict";

  function hexToRgb(hex) {
    if (!hex || hex === "rgba(0,0,0,0)") return null;
    hex = hex.replace(/^#/, "");
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return r + " " + g + " " + b;
  }

  function applyColors(partner, sectionEl) {
    if (!sectionEl) return;

    var bgRgb = hexToRgb(partner.background);
    if (bgRgb) {
      sectionEl.style.setProperty("--background", bgRgb);
      sectionEl.classList.add("bg-custom");
      sectionEl.classList.remove("section-blends");
    }

    var txtRgb = hexToRgb(partner.text_color);
    if (txtRgb) {
      sectionEl.style.setProperty("--text-color", txtRgb);
      sectionEl.classList.add("text-custom");
    }
  }

  function renderBanner(partner, container) {
    while (container.firstChild) container.removeChild(container.firstChild);

    if (partner.logo) {
      var img = document.createElement("img");
      img.className = "partner-logo";
      img.src = partner.logo;
      img.alt = (partner.name || "Partner") + " logo";
      img.loading = "eager";
      img.fetchPriority = "high";
      img.width = parseInt(container.getAttribute("data-logo-width"), 10) || 80;
      if (partner.logo_ratio) img.height = Math.round(img.width * partner.logo_ratio);
      container.appendChild(img);
    }

    if (partner.welcome_text) {
      var div = document.createElement("div");
      div.className = "partner-welcome";
      // welcome_text is admin-controlled rich text from the utm_partners metaobject.
      div.innerHTML = partner.welcome_text;
      container.appendChild(div);
    }

    applyColors(partner, container.closest(".section"));
  }

  function init(banner) {
    if (banner.hasAttribute("data-avlx-partner-ready")) return;
    banner.setAttribute("data-avlx-partner-ready", "");

    var dataEl = document.getElementById("avlx-partner-data-" + banner.getAttribute("data-avlx-partner-banner"));
    if (!dataEl) return;

    try {
      var parsed = JSON.parse(dataEl.textContent);
      var partner = null;

      if (parsed.designMode && parsed.previewPartner) {
        partner = parsed.previewPartner;
      } else if (banner.hasAttribute("data-partner-index")) {
        partner = (parsed.partners || [])[parseInt(banner.getAttribute("data-partner-index"), 10)];
      }

      if (partner) renderBanner(partner, banner);
    } catch (e) {}

    banner.classList.remove("avlx-partner-banner--pending");
    banner.style.minHeight = "";
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-avlx-partner-banner]").forEach(init);
  }

  initAll();
  document.addEventListener("shopify:section:load", function(e) { initAll(e.target); });
})();
